import React from 'react'
import Dashboard from './components/Dashboard/Dashboard'
import { DashboardProvider } from './context/DashboardContext'
const Index = () => {
  return (
    <DashboardProvider>
      <Dashboard />
    </DashboardProvider>

  )
}

export default Index